import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dashboard-table-view',
  standalone: false,
  templateUrl: './dashboard-table-view.component.html',
  styleUrls: ['./dashboard-table-view.component.scss']
})
export class DashboardTableViewComponent {
  @Input() groupedByDeviceGroups: any;

  constructor() { }
}
